/** Adds the configured URL gift once per cart, with _gwp: "true". */
(function () {
  const configEl = document.getElementById('auto-add-gwp-config');
  if (!configEl || window.urlGiftAutoAddStarted) return;

  let config;
  try {
    config = JSON.parse(configEl.textContent);
  } catch (error) {
    console.error('[auto-add-gwp] Invalid config', error);
    return;
  }

  const variantId = Number(config.variantId);
  const trigger = String(config.trigger || '').trim().replace(/^[?&]+/, '');
  if (!trigger || !Number.isSafeInteger(variantId) || variantId <= 0) return;

  const exactParameter = trigger.includes('=') ? [...new URLSearchParams(trigger)] : null;
  // A trigger describes one query parameter, rather than an entire URL.
  if (exactParameter && exactParameter.length !== 1) return;

  function matchesTrigger(key, value) {
    if (exactParameter) {
      return key === exactParameter[0][0] && value === exactParameter[0][1];
    }
    return key === trigger || value === trigger;
  }

  if (![...new URLSearchParams(window.location.search)].some(([key, value]) => matchesTrigger(key, value))) return;
  window.urlGiftAutoAddStarted = true;

  function cleanUrl() {
    const url = new URL(window.location.href);
    const params = new URLSearchParams();
    for (const [key, value] of url.searchParams) {
      if (!matchesTrigger(key, value)) params.append(key, value);
    }
    url.search = params.toString();
    try {
      window.history.replaceState(window.history.state, '', `${url.pathname}${url.search}${url.hash}`);
    } catch (error) {
      console.warn('[auto-add-gwp] Could not remove URL trigger', error);
    }
  }

  function getCartSections() {
    const sections = ['mini-cart', 'cart-icon-bubble', 'mobile-cart-icon-bubble'].map((id) => ({
      id,
      element: document.getElementById(id),
    }));
    // These dynamic section IDs are only present on the full cart page.
    ['main-cart-items', 'main-cart-footer'].forEach((id) => {
      const sectionId = document.querySelector(`#${id}[data-id]`)?.dataset.id;
      if (sectionId) sections.push({ id: sectionId, element: document.getElementById(`shopify-section-${sectionId}`) });
    });
    return sections.filter((section) => section.element);
  }

  function renderCartSections(data, sections) {
    const parser = new DOMParser();
    sections.forEach((section) => {
      const html = data.sections?.[section.id];
      if (!html) return;
      const content = parser.parseFromString(html, 'text/html').querySelector('.shopify-section');
      if (content) section.element.innerHTML = content.innerHTML;
    });
  }

  async function run() {
    try {
      const cartResponse = await fetch(config.cartUrl, {
        headers: { Accept: 'application/json' },
        cache: 'no-store',
      });
      if (!cartResponse.ok) throw new Error('Failed to check cart for the URL gift');
      const cart = await cartResponse.json();

      const alreadyInCart = (cart.items || []).some((item) => (
        Number(item.variant_id || item.id) === variantId && item.properties?._gwp === 'true'
      ));
      if (alreadyInCart) {
        cleanUrl();
        return;
      }

      const sections = getCartSections();
      const body = { items: [{ id: variantId, quantity: 1, properties: { _gwp: 'true' } }] };
      if (sections.length) {
        body.sections = sections.map((section) => section.id);
        body.sections_url = window.location.pathname;
      }
      const addResponse = await fetch(config.cartAddUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      });
      const data = await addResponse.json();
      if (!addResponse.ok) throw new Error(data.description || data.message || 'Failed to add URL gift');

      cleanUrl();
      try {
        renderCartSections(data, sections);
      } catch (error) {
        console.warn('[auto-add-gwp] Cart UI refresh failed', error);
      }
      document.dispatchEvent(new CustomEvent('cart:updated'));
      document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
        detail: { product: data, gwpAutoAdd: true },
      }));
    } catch (error) {
      console.error('[auto-add-gwp]', error);
    }
  }

  function start() {
    // Serialize gift checks across tabs where the browser supports Web Locks.
    const task = window.navigator.locks
      ? window.navigator.locks.request('url-gift-auto-add', run)
      : run();
    task.catch((error) => console.error('[auto-add-gwp]', error));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
